var link_viewer_default = {
  "fontElementMap": "r2mTc",
  "link": "_9du8l",
  "linkInEditor": "-lAPq",
  "linkInViewer": "eA-UF",
  "toolbarUrlContainer": "vVW5c",
  "toolbarUrl": "cbo-m",
  "toolbarUrlAnchor": "MDdCk"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
